import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getVerificationRules = createAsyncThunk(
  '/getVerificationRules',
  async () => {
    const response = await axios.get('/GetVerificationRules');
    return response.data;
  }
);

export const getVerificationRuleDetails = createAsyncThunk(
  '/getVerificationRuleDetails',
  async (id) => {
    const response = await axios.get(`/GetVerificationRuleDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const verificationRulesSlice = createSlice({
  name: 'verificationRules',
  initialState: {
    loading: false,
    error: '',
    VerificationRules: [],
    VerificationRuleDescriptions: [],
    SelectedAppTranslationId: 0,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.VerificationRuleDescriptions = [];
    }
  },
  extraReducers: {
    [getVerificationRules.pending]: (state) => {
      state.loading = true;
    },
    [getVerificationRules.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getVerificationRules.fulfilled]: (state, action) => {
      state.VerificationRules = action.payload;
      state.loading = false;
    },
    [getVerificationRuleDetails.pending]: (state) => {
      state.loading = true;

    },
    [getVerificationRuleDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getVerificationRuleDetails.fulfilled]: (state, action) => {
      state.VerificationRuleDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.VerificationRuleDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const verificationRulesActions = verificationRulesSlice.actions;

export default verificationRulesSlice;
